import React, { useState } from 'react';
import './shortcut-collapse.less';
import { Scrollbars } from '@meitu/saas-ui';
import { ChartType } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';
import { TextShortcut } from './blocks';
import ChartShortcut from './blocks/chart-shortcut';
import ChartSubPanel from './panels/chart-sub-panel';

type SubPanel = 'chart';

const ShortcutCollapse = () => {
    const [subPanel, setSubPanel] = useState<SubPanel | null>(null);
    const openChartPanel = () => setSubPanel('chart');

    const addChart = async (presetId: string) => {
        const resultLayer = await editor.chartLayer.addChartLayerByPreset(presetId);

        if (!resultLayer) return;
        const chartType = resultLayer.data.type;
        const typeIdMap: Record<ChartType, number> = {
            'bar-basic': 69,
            'bar-stacked': 69,
            'bar-horizontal-basic': 68,
            'bar-horizontal-stacked': 68,
            'line-basic': 70,
            'pie-basic': 71,
            'pie-doughnut': 71,
        };
        const func = `28_176_${typeIdMap[chartType]}`;
        window._stat_track('tpbj_subfunction_click', { func });
        window._stat_track('tpbj_subfunction_tick', { func });
    };

    const closSubPanel = () => {
        setSubPanel(null);
    };

    const subPanelMap = {
        chart: <ChartSubPanel onExit={closSubPanel} onAddChart={addChart} />,
    };

    return (
        <div className="shortcut-collapse">
            {subPanel ? subPanelMap[subPanel] : null}
            <Scrollbars autoHide>
                <div className="shortcut-collapse__content">
                    <TextShortcut />
                    <ChartShortcut onOpenChartPanel={openChartPanel} onAddChart={addChart} />
                </div>
            </Scrollbars>
        </div>
    );
};

export default React.memo(ShortcutCollapse);
